import { AnyNode } from "@p0security/shared/types/assessment/data/index";
import { Typography } from "@p0security/ui";
import { ResizableTableColumnType } from "components/ResizableTable";

import { LinkWithEnvironment } from "../LinkWithEnvironment";

const { Text } = Typography;

export const DetailsColumn = (
  fromData: (
    data: AnyNode
  ) => { disabled?: boolean; key: string; to: string } | undefined
): ResizableTableColumnType<AnyNode> => ({
  width: 50,
  ellipsis: true,
  key: "details",
  render: (_: any, data: AnyNode) => {
    const props = fromData(data);
    if (!props) return null;
    if (props.disabled) return <Text type="secondary">view</Text>;
    const { key, ...rest } = props;
    return (
      <LinkWithEnvironment key={key} {...rest}>
        view
      </LinkWithEnvironment>
    );
  },
});
